import EmployeeDashboard from './EmployeeDashboard';
export default EmployeeDashboard;
